import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCardFooter,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CNav,
  CNavItem,
  CNavLink,
  CDropdownItem,
  CDropdownMenu,
  CDropdown,
  CDropdownToggle,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Cards from "../../../../components/Cards/Cards";
import CommunityContent from "../../../../components/CommunityContent";
import Interface from "../../../../components/Interface";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

class RoomShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // community_box: {},
      documents_box: {},
      discussions_box: {},
      // activities_box: {},
      // members_box: {},
      // content: "main",
      inputSearch: "",
      search: "",
      room: null,
      // tab: 1,
      key: 0,
      iframe: false,
      url: null,
      title: null,
      meet: null,
      isStudent: false,
      // statistics: false
      confirmExitModal: false
    };

    this.error = this.error.bind(this);
    this.signOut = this.signOut.bind(this);
    this.hasPrivilege = this.hasPrivilege.bind(this);
  }

  openActivity = data => {};

  openDocument = data => {};

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    this.setState({
      isStudent: this.props.user.user_roles.some(item => item.role_id === 7)
    });

    this.props.setObj(21, id, this.props.currentRoute);

    axios
      .get(`${URL.api}community/room/singleView/${id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            room: resp.data.data,
            // members_box: {
            //   type: 4,
            //   items: resp.data.data.room_user.slice(0, 6)
            // },
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        { user: this.props.user.user.id, room: id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            // activities_box: { type: 2, items: resp.data.data.slice(0, 6) }
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .post(
        `${URL.api}content/doc/listRoom`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            documents_box: {
              type: 5,
              items: resp.data.data
                .filter(item => item.folder === false)
                .slice(0, 6)
            }
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .post(
        `${URL.api}communication/forum/list`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            discussions_box: {
              type: 3,
              items: resp.data.data
                .filter(item => item.forum_id === null)
                .slice(0, 6)
            }
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  click() {
    let objDocuments = {
      title: "Documentos"
    };
    let objDiscussions = {
      title: "Discussões"
    };
    this.setState(
      () => ({
        loading: true,
        documents_box: objDocuments,
        discussions_box: objDiscussions
      }),
      () => {
        // this.state.socket.emit('userConected', data);
      }
    );
  }

  hasPrivilege() {
    if (!this.state.room.room.class) {
      const user = this.state.room.room_user.find(
        item => item.user_id === this.props.user.user.id
      );

      if (user) {
        return user.administrator;
      }
    }

    this.props.history.push("/room/me");
  }

  navigate(pathname) {
    window.history.pushState("", "", pathname);
    this.setState(state => ({ key: (state.key + 1) % 2 }));
  }

  getContent() {
    const path = window.location.pathname.substr(1).split("/");
    if (path.length === 2) {
      return "main";
    }
    if (path.length === 3) {
      return path[2];
    }

    return `${path[2]}SingleView`;
  }

  openUrl(title, url) {
    this.setState({
      iframe: true,
      url,
      title
    });
  }

  openMeet = url => {
    this.setState(
      {
        meet: url
      },
      () => {
        window.open(this.state.meet);
      }
    );
  };

  signOut = () => {
    this.setState(
      {
        loading: true
      },
      () => {
        let obj = {
          user_id: this.props.user.user.id,
          room_id: this.props.match.params.id
        };

        axios
          .post(`${URL.api}community/room_user/deleteByUserRoom`, obj, {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          })
          .then(response => {
            if (response.data.success) {
              toastr.success("Sucesso", "Você saiu da comunidade.");
              this.props.history.push("/dashboard");
            } else {
              toastr.error("Falha", "Não foi possível sair da comunidade.");
            }
          })
          .catch(error => {
            toastr.error("Erro", "Ocorreu um erro ao sair da comunidade.");
            this.setState({
              loading: false
            });
          });
      }
    );
  };

  render() {
    const room = this.state.room && this.state.room.room;
    const { id } = this.props.match.params;

    const modules =
      this.props.user.user_modules?.map(module => module.id) || [];

    const hasAdaptative = modules.includes(17);

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/room/me", to: "/room/me" }]}
        />
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            url={this.state.url}
            title={this.state.title}
            botoes={0}
            onClose={() => this.setState({ iframe: false })}
          />
        )}
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            <CCard>
              <CCardBody
                className="d-flex align-items-end bg-primary text-white"
                style={{
                  padding: "1rem 1.25rem",
                  height: "120px",
                  borderTopRightRadius: "0.25rem",
                  borderTopLeftRadius: "0.25rem"
                }}
              >
                <div className="d-flex" style={{ flex: 1 }}>
                  <h3 className="community-room-show-title">{room.name}</h3>
                </div>
              </CCardBody>
              <CCardFooter className="p-0">
                <div className="d-flex w-100 overflow-hidden">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      height: "100%",
                      width: "100%",
                      overflow: "hidden",
                      flex: 1,
                      marginRight: "1rem"
                    }}
                  >
                    <CNav
                      variant="tabs"
                      className="nav-underline nav-underline-primary flex-nowrap"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <CNavItem>
                        <CNavLink
                          className="p-3"
                          active={this.getContent().includes("main")}
                          onClick={() => this.navigate(`/room/${id}`)}
                        >
                          Avisos
                        </CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink
                          className="h-100 d-flex align-items-center justify-content-center"
                          active={this.getContent().includes("activit")}
                          onClick={() =>
                            this.navigate(`/room/${id}/activities`)
                          }
                        >
                          Atividades
                        </CNavLink>
                      </CNavItem>
                      <CDropdown inNav>
                        <CDropdownToggle
                          color="white"
                          className="d-md-none card-header-action remove-caret h-100 d-flex align-items-center justify-content-center"
                        >
                          <i className="fa fa-ellipsis-v"></i>
                        </CDropdownToggle>
                        <CDropdownMenu
                          placement="bottom-end"
                          className="classroom-tab-menu"
                        >
                          {hasAdaptative && (
                            <CDropdownItem
                              active={this.getContent().includes("trail")}
                              onClick={() =>
                                this.navigate(`/room/${id}/trails`)
                              }
                            >
                              Trilhas
                            </CDropdownItem>
                          )}
                          <CDropdownItem
                            active={this.getContent().includes("forum")}
                            onClick={() => this.navigate(`/room/${id}/forums`)}
                          >
                            Fórum
                          </CDropdownItem>
                          <CDropdownItem
                            active={this.getContent().includes("user")}
                            onClick={() => this.navigate(`/room/${id}/users`)}
                          >
                            Membros
                          </CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                      <div className="d-none d-md-flex">
                        {hasAdaptative && (
                          <CNavItem>
                            <CNavLink
                              className="h-100 d-flex align-items-center justify-content-center"
                              active={this.getContent().includes("trail")}
                              onClick={() =>
                                this.navigate(`/room/${id}/trails`)
                              }
                            >
                              Trilhas
                            </CNavLink>
                          </CNavItem>
                        )}
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("doc")}
                            onClick={() => this.navigate(`/room/${id}/docs`)}
                          >
                            Documentos
                          </CNavLink>
                        </CNavItem>
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("forum")}
                            onClick={() => this.navigate(`/room/${id}/forums`)}
                          >
                            Fórum
                          </CNavLink>
                        </CNavItem>
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("user")}
                            onClick={() => this.navigate(`/room/${id}/users`)}
                          >
                            Membros
                          </CNavLink>
                        </CNavItem>
                      </div>
                    </CNav>
                  </div>
                  <div
                    style={{
                      width: "300px",
                      display: "flex",
                      alignItems: "center",
                      paddingRight: "1.25rem"
                    }}
                  >
                    <CInputGroup
                      className="d-flex justify-content-end"
                      style={{ flexWrap: "nowrap", paddingRight: "1.25rem" }}
                    >
                      <CInput
                        className="form-control"
                        type="text"
                        style={{ width: "auto", height: "auto" }}
                        placeholder="Pesquisar"
                        onChange={e =>
                          this.setState({ inputSearch: e.target.value })
                        }
                      ></CInput>
                      <CInputGroupAppend>
                        <CButton
                          color="primary"
                          onClick={() =>
                            this.setState(state => ({
                              search: state.inputSearch
                            }))
                          }
                        >
                          <i className="fa fa-search"></i>{" "}
                        </CButton>
                      </CInputGroupAppend>
                    </CInputGroup>
                    <i
                      className="fa fa-sign-out fa-lg"
                      style={{ cursor: "pointer" }}
                      onClick={() => this.setState({ confirmExitModal: true })}
                    ></i>
                  </div>
                </div>
              </CCardFooter>
            </CCard>
            <div className="row">
              <div className="col-lg-9 col-sm-12">
                <CommunityContent
                  key={this.state.key}
                  hasPrivilege={this.hasPrivilege()}
                  isStudent={this.state.isStudent}
                  content={this.getContent()}
                  search={this.state.search}
                  history={this.props.history}
                  navigate={this.navigate.bind(this)}
                  match={this.props.match}
                  isRoom
                  currentRoute={this.props.currentRoute}
                />
              </div>
              <div className="col-lg-3 col-sm-12">
                <Cards
                  header="Documentos recentes"
                  body={this.state.documents_box}
                  footer=""
                  openUrl={(title, url) => this.openUrl(title, url)}
                  function={this.openDocument}
                />
                <Cards
                  header="Discussões recentes"
                  body={this.state.discussions_box}
                  footer=""
                  function={id =>
                    this.navigate(
                      `/room/${this.props.match.params.id}/forums/${id}`
                    )
                  }
                />
              </div>
            </div>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />

        <CModal
          show={this.state.confirmExitModal}
          onClose={() => this.setState({ confirmExitModal: false })}
          size="lg"
        >
          <CModalHeader closeButton className="modal-header-styled">
            <span className="modal-title-text">Confirmação de Saída</span>{" "}
          </CModalHeader>
          <CModalBody className="modal-body-styled">
            Você tem certeza que deseja sair desta comunidade?
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              onClick={() => {
                this.setState({ confirmExitModal: false });
                this.signOut();
              }}
            >
              Sair
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => this.setState({ confirmExitModal: false })}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomShow);
